import React, { useState } from 'react';
import { Box, Typography, Paper, Button, Alert } from '@mui/material';
import QueueTable from '../Components/Validation/QueueTable';
import ProgressBar from '../Components/Validation/ProgressBar';

export default function ValidationQueue() {
  const [actionMessage, setActionMessage] = useState<string | null>(null);

  const handleBulkAction = async (action: string, selectedIds: number[]) => {
    try {
      let endpoint = '';
      let method = 'POST';
      
      if (action === 'retry') {
        endpoint = '/api/validation/entries/retry-failed';
      } else if (action === 'clear') {
        endpoint = '/api/validation/queue/clear';
      }

      const response = await fetch(endpoint, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ entry_ids: selectedIds }),
      });

      if (!response.ok) {
        throw new Error(`Action failed: ${response.status}`);
      }

      setActionMessage(`Successfully ${action === 'retry' ? 'retried' : 'cleared'} ${selectedIds.length} items`);
      setTimeout(() => setActionMessage(null), 3000);
    } catch (err: any) {
      setActionMessage(err.message);
    }
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          Validation Queue
        </Typography>
      </Box>

      {actionMessage && (
        <Alert severity={actionMessage.includes('Successfully') ? 'success' : 'error'} sx={{ mb: 2 }}>
          {actionMessage}
        </Alert>
      )}

      <ProgressBar />
      
      <Box sx={{ mt: 3 }}>
        <QueueTable onBulkAction={handleBulkAction} />
      </Box>
    </Box>
  );
}
